import { BrowserRouter, Routes, Route, Navigate, ScrollRestoration, } from 'react-router-dom';
import './App.css';
import './css/login.css'
import './css/appTheme.css'
import Layout from './components/layout/layout';
import Dashboard from './pages/dashboard/dashboard';
import HomePage from './pages/home/homePage';
import Support from './pages/support/support';
import PrivateRoutes from './utils/PrivateRoutes';
import AccountSetting from './pages/accountSetting/accountSetting';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-h5-audio-player/lib/styles.css';
import 'react-h5-audio-player/lib/styles.less'
// import 'react-h5-audio-player/src/styles.scss'
import MyProvider from './contexts/SideBar';
import Pricing from './pages/Pricing/pricing';
import PasswordResetPage from './pages/PasswordResetPage/PasswordResetPage';
import Account from './pages/accountSettingFeatures/account/account';
import RecordingQuality from './pages/accountSettingFeatures/recordingQuality/recordingQuality';
import DefaultAudioFormat from './pages/accountSettingFeatures/defaultAudioFormat/defaultAudioFormat';
import SettingPassword from './pages/accountSettingFeatures/settingPassword/settingPassword';
import SyncWithCloud from './pages/accountSettingFeatures/syncWithCloud/syncWithCloud';
import SupportSetting from '../src/pages/accountSettingFeatures/support/support';
import ManagePlan from './pages/accountSettingFeatures/managePlan/managePlan';
import RedirectPage from './pages/RedirectPage/RedirectPage';
import { GoogleOAuthProvider } from "@react-oauth/google"
import ScrollToTop from './utils/scrollToTop';
import BlogPage from './Blogs/blogPage';
import BlogDetails from './components/BlogSection/BlogDetails';
import BlogSection from './components/BlogSection/BlogSection';
import MobileDashboard from './pages/MobileDashboard';
import DashboardWrapper from './pages/DashboardWrapper';
import PricingWrapper from './pages/PricingWrapper';


function Main() {

  return (
    <Layout>
      <ToastContainer />
      <ScrollToTop />
      <Routes>
        <Route exact path='/' element={<HomePage />} />
        <Route exact path='support' element={<Support />} />
        {/* <Route exact path='pricing' element={<Pricing />} /> */}
        <Route exact path='pricing' element={<PricingWrapper />} />
        {/* <Route exact path='/blog' element={<BlogPage />} /> */}
        <Route  path='/blog' element={<BlogSection />} />
        <Route exact path="/blog/:slug" element={<BlogDetails />} />
        <Route path="/redirect" element={<RedirectPage />} />
        <Route exact path="password/reset/:token" element={<PasswordResetPage />} />
        {/* <Route exact path='/mobile-dashboard' element={<MobileDashboard />} /> */}

        <Route element={<PrivateRoutes />}> 
          <Route exact path='dashboard' element={<DashboardWrapper />} />
          <Route path="accountsetting" element={<AccountSetting />}>
            <Route index element={<Navigate to="account" replace />} />
            <Route path="account" element={<Account />} />
            <Route path="settingpassword" element={<SettingPassword />} />
            <Route path="recordingquality" element={<RecordingQuality />} />
            <Route path="audioformat" element={<DefaultAudioFormat />} />
            <Route path="syncwithcloud" element={<SyncWithCloud />} />
            <Route path='support' element={<SupportSetting />} />
            <Route path="manage-plan" element={<ManagePlan />} />
          </Route>
        </Route>
      </Routes>
    </Layout>
  );
}

function App() {

  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  return (
    <GoogleOAuthProvider clientId={clientId}>
        <BrowserRouter>
      <MyProvider>
          {/* <ScrollRestoration />  */}
          <Main />
      </MyProvider>
        </BrowserRouter>
    </GoogleOAuthProvider>

  );
}

export default App;